<template>
  <li @click="handleClick" v-bind="$attrs"><slot></slot></li>
</template>

<script>
export default {
  name: 'XDropdownItem',
  inheritAttrs: false,
  methods: {
    handleClick (event) {
      let id = event.currentTarget.getAttribute('_id')
      let name = event.currentTarget.innerHTML
      this.$parent.$parent.$emit('selectItem', event, id, name)
    }
  }
}
</script>
<style scoped>
  li{
    cursor: pointer;
    /*font-size: 11px;*/
    font-size: 13px;
    margin-bottom: 2px;
    padding: 3px 12px;
  }
  li:hover{
    background-color: #f3f3f3;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/xdropdown/XDropdownItem.vue